import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ValidateZipCode, ValidateZipCodeResponse } from '@models/swagger';
import { ValidateZipCodeFailure, ValidateZipCodeRequest, ValidateZipCodeSuccess } from './actions';
import { ValidateZipCodeParams, ValidateZipCodeService } from './service';

@Injectable()
export class ValidateZipCodeEffects {
  private readonly actions$ = inject(Actions);
  private readonly validateZipCodeService = inject(ValidateZipCodeService);

  validateZipCode$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ValidateZipCodeRequest),
      switchMap(({ body, parameters }: { body: ValidateZipCode; parameters?: ValidateZipCodeParams }) =>
        this.validateZipCodeService.validateZipCode(body, parameters).pipe(
          map((data: ValidateZipCodeResponse) => ValidateZipCodeSuccess({ data })),
          catchError(error => of(ValidateZipCodeFailure({ error })))
        )
      )
    )
  );

}
